import { rem } from 'polished';
import styled from 'styled-components';

import { Button } from '@vimeo/iris/components';
import { Apple, Facebook, GoogleGColor } from '@vimeo/iris/icons';

export const AppleIcon = styled(Apple)`
  &&& {
    width: ${rem(18)};
  }
`;

export const GoogleIcon = styled(GoogleGColor)`
  &&& {
    width: ${rem(21)};
  }
`;

export const FacebookIcon = styled(Facebook)`
  &&& {
    width: ${rem(18)};
    vertical-align: top;
    margin-top: ${rem(3)};
    & > * {
      fill: white;
    }
  }
`;

export const FacebookIconContainer = styled.div`
  border-radius: 100%;
  overflow: hidden;
  background-color: #1877f2;
  margin-right: ${rem(10)};
  width: ${rem(21)};
  height: ${rem(21)};
`;

export const SocialButton = styled(Button).attrs({ size: 'lg' })`
  &&& {
    &.f2pPilotRegLogin {
      width: 100%;
      font-size: ${rem(14)};
    }
    width: ${rem(300)};
    margin: 0 auto;
    background-color: var(--vimeo-colors-fill-surface);
    color: var(--vimeo-colors-text-primary);
    border: ${rem(1)} solid var(--vimeo-colors-stroke);
    svg {
      min-width: auto;
    }
    &:hover {
      background-color: var(--vimeo-colors-fill-surface);
    }
  }
`;
